import { useFormikContext } from "formik";
import { SudoButton } from "src/sudokit/components/SudoButton";

function SubmitButton({ version }) {
  const { values, dirty, submitForm, isSubmitting } = useFormikContext();

  const hasChanges = dirty || JSON.stringify(values) !== JSON.stringify(version.definition);

  return (
    <SudoButton
      type="submit"
      className="mt-0"
      disabled={!hasChanges || isSubmitting}
      variant="primary"
      onClick={submitForm}
    >
      Save
    </SudoButton>
  );
}

export default SubmitButton;
